import type { TaskStatus } from '../../services/api/types.gen';

export const formatTaskStatusLabel = (status: TaskStatus): string =>
  status
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, char => char.toUpperCase());
